import axios from "axios";
import { getServiceURL } from "./utils";

const API = axios.create({
  baseURL: getServiceURL(),
});

export const BannerService = {
  getAllBannersByRestaurantId: async (restaurantId) => {
    return API.get(`/banners/all/${restaurantId}`);
  },
};

export const RestaurantService = {
  getRestaurantByDomainName: async (domainName) => {
    return API.get(`/restaurants/user/${domainName}`);
  },
};

export const TableService = {
  getAllTablesByRestaurantId: async (id) => {
    return API.get(`/tables/all/${id}`);
  },
};

export const MenuService = {
  getAllMenuItems: async (id) => {
    return API.get(`/menus/all/${id}?availability=true`);
  },
};

export const OrderService = {
  placeOrder: async (restaurantId, data) => {
    return API.post(`/orders/${restaurantId}`, data);
  },
  getOrderById: async (id) => {
    return API.get(`/orders/${id}`);
  },
  updateOrder: async (id, data) => {
    return API.put(`/orders/${id}`, data);
  },
  getActiveOrderByMobile: async (restaurantId, mobileNumber) => {
    return API.get(`/orders/active/${restaurantId}/${mobileNumber}`);
  },
  cancelOrderCustomer: async (orderId) => {
    return API.post(`/orders/cancel-customer/${orderId}`);
  },
  editOrderCustomer: async (orderId, data) => {
    return API.put(`/orders/edit-customer/${orderId}`, data);
  },
};

export const PaymentService = {
  getPaymentQR: async (restaurantId) => {
    return API.get(`/payments/checkQR/${restaurantId}`);
  },
};
